/* eslint-disable func-style */
// 发票管理
// const TransactionInfo = () => import('@/pages/stu_information/TransactionInfo.vue');
// const BriefDepositControl = () => import('@/pages/stu_information/BriefDepositControl.vue')

const ReceiptRouter = [
	// { path: '/TransactionInfo', name: 'TransactionInfo', component: TransactionInfo },//电子发票维护
	// { path: '/BriefDepositControl', name: 'BriefDepositControl', component: BriefDepositControl },//电子发票维护

];

export default ReceiptRouter;
